import { ORDER_STATUS } from '@vindr/services/constants/order.constant';
import { PERMISSIONS } from '@vindr/services/constants/permissions.constant';
import keycloak from '@vindr/services/keycloak';
import { AssignmentIndOutlined, DeleteOutlined, EditOutlined } from '@vindr/icons';
import { ItemType } from '@vindr/ui/src/components/ui/PopupContextMenu/PopupContextMenu';
import { useTranslation } from 'react-i18next';

export const MENU_TYPE = {
  ASSIGN: 'assign',
  EDIT: 'edit',
  DELETE: 'delete',
};

const useContextMenu = ({ handleContextMenuSelect }): ItemType[] => {
  const { t } = useTranslation('Vindoc');

  return [
    {
      key: MENU_TYPE.ASSIGN,
      label: t('Assign'),
      icon: <AssignmentIndOutlined className="text-3xl" />,
      onClick: (record) => handleContextMenuSelect(MENU_TYPE.ASSIGN, record),
      disabled: (record) =>
        [ORDER_STATUS.NEW, ORDER_STATUS.ARRIVED, ORDER_STATUS.CANCEL].includes(record.status) ||
        !keycloak.hasOneOfPerm([PERMISSIONS.order.assign]),
    },
    {
      key: MENU_TYPE.EDIT,
      label: t('Edit'),
      icon: <EditOutlined className="text-3xl" />,
      onClick: (record) => handleContextMenuSelect(MENU_TYPE.EDIT, record),
      disabled: !keycloak.hasOneOfPerm([PERMISSIONS.order.update]),
    },
    {
      key: MENU_TYPE.DELETE,
      label: t('Delete'),
      icon: <DeleteOutlined className="text-3xl" />,
      onClick: (record) => handleContextMenuSelect(MENU_TYPE.DELETE, record),
      disabled: !keycloak.hasOneOfPerm([PERMISSIONS.order.delete]),
    },
  ];
};

export default useContextMenu;
